import gql from 'graphql-tag';

export const DeleteLabel = gql`
  mutation DeleteLabel($organizationId: ID!, $labelId: ID!) {
    deleteLabel(organizationId: $organizationId, labelId: $labelId) {
      id
    }
  }
`;
